import { Request } from '~src/httpClient/serverApi/requests/Request';
import { IResult } from '~src/httpClient/serverApi/types/IResponse';


export interface IRestoreSiteEncryptionDataKeyParams {
  dataKeyId: string;
}

export interface RestoreSiteEncryptionDataKeyResult extends IResult {}

export class RestoreSiteEncryptionDataKeyRequest extends Request<IRestoreSiteEncryptionDataKeyParams, RestoreSiteEncryptionDataKeyResult> {
  constructor(params: IRestoreSiteEncryptionDataKeyParams) {
    super('restoreSiteEncryptionDataKey', params);
  }
}